export default "__VITE_ASSET__ATcK3BMJ__"